import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';

// Self-contained zoom slider. Drag state lives HERE, not in the chart, so
// dragging re-renders only this component - the bubble and thumb track live,
// and the chart itself re-renders exactly once, on release.
// The % bubble portals to document.body so no ancestor overflow can clip it.
// step 0.1, and min 0.2 NOT 0.25: a range input steps from its min, so 0.25 put
// the grid on 25, 35, 45 rather than 20, 30, 40, and 0.2 lands every step on a
// clean decade up to exactly 800 (organise-app T158).
const ZoomSlider = ({ zoomLevel, onCommit, min = 0.2, max = 8, step = 0.1 }) => {
    const [pending, setPending] = useState(null);
    const inputRef = useRef(null);
    const value = pending ?? (zoomLevel || 1);

    const commit = () => {
        if (pending !== null) {
            onCommit(pending);
            setPending(null);
        }
    };

    const pct = ((value - min) / (max - min)) * 100;
    const rect = inputRef.current?.getBoundingClientRect();

    return (
        <div className="relative flex items-center">
            {pending !== null && rect && createPortal(
                <div
                    className="px-1.5 py-0.5 text-xs font-medium rounded bg-gray-800 text-white pointer-events-none whitespace-nowrap"
                    style={{
                        position: 'fixed',
                        top: rect.top - 28,
                        left: rect.left + (pct / 100) * rect.width - 16,
                        zIndex: 9999
                    }}
                >
                    {Math.round(value * 100)}%
                </div>,
                document.body
            )}
            <input
                ref={inputRef}
                type="range"
                min={min}
                max={max}
                step={step}
                value={value}
                onChange={(e) => setPending(Number(e.target.value))}
                onMouseUp={commit}
                onTouchEnd={commit}
                onKeyUp={commit}
                className="gantt-zoom-slider w-[480px] cursor-pointer"
            />
        </div>
    );
};

export default ZoomSlider;
